import { Sport } from '#src/__generated__/globalTypes.ts';
import { WinterRound } from '#src/atoms/icons/WinterRound.tsx';

import setBackgroundImage from './assets/background/background.webp';
import setLeftBackgroundImage from './assets/background/freeze-left.webp';
import setRightBackgroundImage from './assets/background/freeze-right.webp';
import playFootballBackgroundImage from './assets/footballBackground.webp';
import playFootballFieldImage from './assets/footballField.webp';
import playNbaBackgroundImage from './assets/nbaBackground.webp';
import playNbaFieldImage from './assets/nbaField.webp';
import replayDialogFootballBackground from './assets/replayDialog/football.webp';
import replayDialogNBABackground from './assets/replayDialog/nba.webp';
import setLogoImage from './assets/set-logo.svg';
import playVoucherIcon from './assets/voucher.svg';
import commonPacksHeaderImage from './assets/wntr-header.webp';
import commonPacksLogoImage from './assets/wntr-logo.svg';
import cardRevealSwipeIconImage from './assets/wntr-series-icon.svg';

type SetPlaySportAssets = {
  backgroundImage: string;
  fieldImage: string;
};

const DEFAULT_SET_PLAY_SPORT_ASSETS: SetPlaySportAssets = {
  backgroundImage: playFootballBackgroundImage,
  fieldImage: playFootballFieldImage,
};

const SET_PLAY_SPORT_ASSETS: Partial<Record<Sport, SetPlaySportAssets>> = {
  [Sport.FOOTBALL]: DEFAULT_SET_PLAY_SPORT_ASSETS,
  [Sport.NBA]: {
    backgroundImage: playNbaBackgroundImage,
    fieldImage: playNbaFieldImage,
  },
};

const background = {
  background: `
      url("${setLeftBackgroundImage}") left  top / contain no-repeat,
      url("${setRightBackgroundImage}") right  top / contain no-repeat,
      url("${setBackgroundImage}") center top / cover no-repeat
    `,
  backgroundBlendMode: 'color-dodge, color-dodge, normal',
};

export const SET_WINTER = {
  slug: 'winter',
  cardEditionSlugs: ['winter', 'ice_breaker'] as const,
  skins: [],
  colors: {
    main: 'var(--c-set-winter-surface-primary)',
    swipeEffectColor: '#00A2F3',
  },
  visual: {
    commonPacks: {
      headerImage: commonPacksHeaderImage,
      logoImage: commonPacksLogoImage,
    },
    cardReveal: {
      swipeIconImage: cardRevealSwipeIconImage,
      background,
      videoSources: null,
    },
    seasonCountdown: null,
    brand: {
      logoImage: setLogoImage,
      SetIcon: WinterRound,
    },
    play: {
      getSportAssets: (sport: Sport) =>
        SET_PLAY_SPORT_ASSETS[sport] || DEFAULT_SET_PLAY_SPORT_ASSETS,
      voucherIcon: playVoucherIcon,
    },
    replayDialog: {
      background: {
        [Sport.FOOTBALL]: replayDialogFootballBackground,
        [Sport.NBA]: replayDialogNBABackground,
        [Sport.BASEBALL]: undefined,
      },
    },
  },
  background,
} as const;
